import { DestroyRef, inject, Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ApiResponse } from '@innovation-os-ng/core/auth';
import { AuthContextSelectors, skipper } from '@innovation-os-ng/core/state';
import { EnvironmentService } from '@innovation-os-ng/core/utils';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, skip, switchMap } from 'rxjs/operators';
import { SubscriptionService } from '../contracts/subscription.service';

@Injectable()
export class ApiSubscriptionService implements SubscriptionService {
  private readonly destroyRef = inject(DestroyRef);
  private readonly restUrl: string = this.environmentService.getRestUrl();

  constructor(
    private readonly http: HttpClient,
    private readonly environmentService: EnvironmentService,
    private readonly store: Store
  ) {}

  public getModuleSubscriptions(tenantUri: string): Observable<Array<string>> {
    return this.store.select(AuthContextSelectors.selectTenantModules(tenantUri)).pipe(skipper())
  }

  public isModuleEnabled(tenantUri: string, moduleId: string): Observable<boolean> {
    return this.store.select(AuthContextSelectors.selectTenantModules(tenantUri))
      .pipe(skipper())
      .pipe(takeUntilDestroyed(this.destroyRef))
      .pipe(map((modules) => modules.indexOf(moduleId) > -1));
  }

  public updateModuleSubscriptions(
    tenantUri: string,
    enable: Array<string> = [], // only changes are posted, not the new status quo
    disable: Array<string> = [] // only changes are posted, not the new status quo
  ): Observable<Array<string>> {
    return this.http
      .post<ApiResponse>(`${this.restUrl}/subscriptions/modules/${tenantUri}`, {
        enable,
        disable
      })
      .pipe(
        switchMap(() => {
          return this.store.select(AuthContextSelectors.selectTenantModules(tenantUri)).pipe(skip(1));
        })
      );
  }
}
